// import React, { useEffect, useState, useMemo } from "react";
// import { API } from "../config/api";
// import { get, post } from "../lib/http";

// const SECTIONS = [
//   { id: 'left-diamond', title: 'Mehfil - Diamond Silver', category: 'diamond-silver', rows: 2, cols: 4, prefix: 'DS-' },
//   { id: 'left-gold', title: 'Mehfil - Diamond Gold', category: 'diamond-gold', rows: 2, cols: 4, prefix: 'DG' },
//   { id: 'left-platinum', title: 'Mehfil - Diamond Platinum', category: 'diamond-platinum', rows: 1, cols: 4, prefix: 'DP' },
//   { id: 'qawwali-left', title: 'Qawwali Court', category: 'platinum', count: 6, prefix: 'P' },
//   { id: 'qawwali-right', title: 'Qawwali Court', category: 'platinum', count: 6, prefix: 'P' },
//   { id: 'right-diamond', title: 'Mehfil - Diamond Silver', category: 'diamond-silver', rows: 2, cols: 4, prefix: 'DS-' },
//   { id: 'right-gold', title: 'Mehfil - Diamond Gold', category: 'diamond-gold', rows: 2, cols: 4, prefix: 'DG' },
//   { id: 'right-platinum', title: 'Mehfil - Diamond Platinum', category: 'diamond-platinum', rows: 1, cols: 4, prefix: 'DP' },
//   { id: 'sofa-left', title: 'Mehfil - 20 Sofa Lounge', category: 'qawwali-sofa', count: 20, prefix: 'PS' },
//   { id: 'sofa-right', title: 'Mehfil - 20  Sofa Lounge', category: 'qawwali-sofa', count: 20, prefix: 'PS' },
//   { id: '44sofa-left', title: 'Qawwali -  44 Sofa Lounge', category: 'mehfil-sofa', count: 44, prefix: 'DS' },
//   { id: '44sofa-right', title: 'Qawwali - 44 Sofa Lounge', category: 'mehfil-sofa', count: 44, prefix: 'DS' }
// ];

// const COLORS = {
//   'diamond-silver': '#9be39b',
//   'diamond-gold': '#6fb7ff',
//   'diamond-platinum': '#ffd97a',
//   'platinum': '#fa8110ff',
//   'mehfil-sofa': '#0c3f85ff',
//   'qawwali-sofa': '#e43e14ff',
//   'stage': '#8b0000'
// };

// const PRICES = {
//   'diamond-silver': 50,
//   'diamond-gold': 75,
//   'diamond-platinum': 100,
//   'platinum': 150,
//   'mehfil-sofa': 40,
//   'qawwali-sofa': 60
// };

// // Simple in-file toast helper (no external lib)
// function ToastContainer({ toasts, removeToast }) {
//   return (
//     <div className="fixed top-4 right-4 z-50 flex flex-col gap-2">
//       {toasts.map(t => (
//         <div key={t.id} className={`px-4 py-2 rounded shadow-lg text-white text-sm ${t.type === 'error' ? 'bg-red-600' : 'bg-green-600'}`}>
//           {t.message}
//           <button onClick={() => removeToast(t.id)} className="ml-3 font-bold">✕</button>
//         </div>
//       ))}
//     </div>
//   );
// }

// export default function StageLayoutWithAPI({
//   userId = null,
//   userName = '',
//   userContact = '',
//   userRole = undefined // optional prop: 'admin' or other
// }) {
//   const [booked, setBooked] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [message, setMessage] = useState(null);

//   // modal state for single-seat booking
//   const [modalOpen, setModalOpen] = useState(false);
//   const [modalSeat, setModalSeat] = useState(null); // { id, display, section }
//   const [guestName, setGuestName] = useState('');
//   const [guestEmail, setGuestEmail] = useState('');
//   const [guestContactState, setGuestContactState] = useState(''); // contact is now optional

//   // small toast state
//   const [toasts, setToasts] = useState([]);
//   const addToast = (message, type = 'success', timeout = 3500) => {
//     const id = Date.now() + Math.random();
//     setToasts(prev => [...prev, { id, message, type }]);
//     if (timeout) setTimeout(() => removeToast(id), timeout);
//   };
//   const removeToast = (id) => setToasts(prev => prev.filter(t => t.id !== id));

//   // Determine admin role:
//   // Priority: userRole prop -> localStorage.bb_user.user.role (adjust based on your auth payload)
//   const isAdmin = useMemo(() => {
//     if (userRole) return userRole === 'admin';
//     try {
//       const stored = JSON.parse(localStorage.getItem('bb_user'));
//       const r = stored?.user?.role || stored?.role || stored?.user?.isAdmin;
//       if (typeof r === 'string') return r === 'admin';
//       return !!r; // if boolean isAdmin true
//     } catch (e) {
//       return false;
//     }
//   }, [userRole]);

//   const seatIdToSection = useMemo(() => {
//     const map = {};
//     SECTIONS.forEach(s => {
//       if (s.rows) {
//         let counter = 1;
//         for (let r = 0; r < s.rows; r++) {
//           for (let c = 0; c < s.cols; c++) {
//             const code = `${s.id}-${s.prefix}${counter}`;
//             map[code] = s;
//             counter++;
//           }
//         }
//       } else if (s.count) {
//         for (let i = 1; i <= s.count; i++) {
//           const code = `${s.id}-${s.prefix}${i}`;
//           map[code] = s;
//         }
//       }
//     });
//     return map;
//   }, []);

//   useEffect(() => {
//     let mounted = true;
//     const loadBooked = async () => {
//       setLoading(true);
//       try {
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const resp = await get(API.layout.listAllBooked,
//           {
//             headers: {
//               Authorization: token ? `Bearer ${token}` : undefined,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         if (!resp.success) throw new Error(`HTTP ${resp.status}`);
//         const body = await resp;
//         if (!mounted) return;
//         const bookedMap = {};
//         const items = body.items || [];
//         for (const it of items) {
//           if (it.seatCode) bookedMap[it.seatCode] = true;
//         }
//         setBooked(bookedMap);
//         setMessage(null);
//       } catch (err) {
//         console.error('Failed to load booked seats', err);
//         setMessage(`Could not load booked seats (server). Showing local state only.`);
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     };
//     loadBooked();
//     return () => { mounted = false; };
//   }, []);

//   const openModalForSeat = (seatId, display, section) => {
//     // Only admin can open modal (add tickets)
//     if (!isAdmin) {
//       // do nothing (or show a tiny toast if you want)
//       addToast('View only: you do not have permission to book seats.', 'error', 2000);
//       return;
//     }
//     if (booked[seatId]) return; // do nothing for already booked seats
//     setModalSeat({ id: seatId, display, section });
//     // prefill with provided user props when available
//     setGuestName(userName || '');
//     setGuestContactState(userContact || '');
//     setGuestEmail('');
//     setModalOpen(true);
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//     setModalSeat(null);
//     setGuestName('');
//     setGuestEmail('');
//     setGuestContactState('');
//   };

//   const buildSeatsPayload = (seatCodes, guest) => {
//     return seatCodes.map(code => {
//       const sec = seatIdToSection[code];
//       return {
//         seatCode: code,
//         sectionUid: sec?.id || null,
//         label: code.split('-').slice(-1)[0],
//         category: sec?.category || null,
//         price: PRICES[sec?.category] || 0,
//         meta: { source: 'web-frontend', guest: guest || null }
//       };
//     });
//   };

//   // save a single-seat booking from modal
//   const handleModalSave = async () => {
//     if (!modalSeat) return;
//     if (!guestName) {
//       addToast('Guest name is required', 'error');
//       return;
//     }

//     const seatCode = modalSeat.id;
//     if (booked[seatCode]) {
//       addToast('Sorry, this seat was just booked by someone else.', 'error');
//       closeModal();
//       return;
//     }

//     setSaving(true);
//     setMessage(null);
//     try {
//       const payloadSeats = buildSeatsPayload([seatCode], { name: guestName, email: guestEmail, contact: guestContactState });
//       const body = {
//         userId: userId || undefined,
//         bookedByName: guestName || userName || undefined,
//         bookedByContact: guestContactState || userContact || undefined,
//         bookingRef: `WEB_${Date.now()}`,
//         seats: payloadSeats
//       };

//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       const resp = await post(API.layout.book, body,
//         {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       const result = await resp;

//       if (!resp.success) {
//         const msg = (result && result.message) ? result.message : `Booking failed`;
//         setMessage(msg);
//         addToast(msg, 'error');
//         if (result && result.conflicts) {
//           const conflicts = result.conflicts.map(c => c.seatCode);
//           setBooked(prev => ({ ...prev, ...conflicts.reduce((acc, c) => (acc[c] = true, acc), {}) }));
//         }
//         throw new Error(msg);
//       }

//       const newly = result.seats || payloadSeats.map(s => s.seatCode);
//       setBooked(prev => {
//         const cp = { ...prev };
//         newly.forEach(s => cp[s] = true);
//         return cp;
//       });
//       setMessage('Booking successful!');
//       addToast(`Booking successful: ${newly.join(', ')}`, 'success');
//       closeModal();
//     } catch (err) {
//       console.error('Modal save error', err);
//       if (!message) {
//         setMessage('Booking failed, try again.');
//         addToast('Booking failed, try again.', 'error');
//       }
//     } finally {
//       setSaving(false);
//     }
//   };

//   const renderButton = (id, display, section) => {
//     const isBooked = !!booked[id];
//     const bg = isBooked ? COLORS[section.category] : 'transparent';
//     const color = isBooked ? '#fff' : '#111';
//     const border = isBooked ? 'transparent' : 'rgba(0,0,0,0.08)';

//     const clickable = isAdmin && !isBooked;

//     return (
//       <button
//         key={id}
//         onClick={clickable ? () => openModalForSeat(id, display, section) : undefined}
//         disabled={!clickable}
//         title={isBooked ? 'Booked' : (isAdmin ? 'Click to book' : 'View only')}
//         className={`w-10 h-10 rounded-full border-2 flex items-center justify-center font-semibold text-xs transition ${isBooked ? '' : (clickable ? 'hover:-translate-y-1 cursor-pointer' : 'cursor-default opacity-90')}`}
//         style={{
//           background: bg,
//           color,
//           borderColor: border,
//         }}
//       >
//         {display}
//       </button>
//     );
//   };

//   // renderTables unchanged except it uses renderButton (already above)
//   const renderTables = (section) => {
//     if (!section) return null;

//     if (section.prefix === 'DS-') {
//       const total = (section.rows || 0) * (section.cols || 0);
//       const nums = Array.from({ length: total }, (_, i) => i + 1);
//       const half = Math.ceil(total / 2);
//       const firstHalf = nums.slice(0, half);
//       const secondHalf = nums.slice(half);
//       const isLeftSection = section.id.includes('left');
//       const leftColumnNums = isLeftSection ? secondHalf : firstHalf;
//       const rightColumnNums = isLeftSection ? firstHalf : secondHalf;

//       const renderButtonForNum = (num) => {
//         const id = `${section.id}-${section.prefix}${num}`;
//         const display = `${section.prefix}${num}`;
//         return renderButton(id, display, section);
//       };

//       return (
//         <div className="flex gap-4 justify-center">
//           <div className="flex flex-col gap-2">
//             {leftColumnNums.map(renderButtonForNum)}
//           </div>

//           <div className="flex flex-col gap-2">
//             {rightColumnNums.map(renderButtonForNum)}
//           </div>
//         </div>
//       );
//     }

//     if (section.prefix === 'DG') {
//       const total = (section.rows || 0) * (section.cols || 0);
//       const nums = Array.from({ length: total }, (_, i) => i + 1);
//       const half = Math.ceil(total / 2);
//       const firstHalf = nums.slice(0, half);
//       const secondHalf = nums.slice(half);
//       const isLeftSection = section.id.includes('left');
//       const leftColumnNums = isLeftSection ? secondHalf : firstHalf;
//       const rightColumnNums = isLeftSection ? firstHalf : secondHalf;

//       const renderButtonForNum = (num) => {
//         const id = `${section.id}-${section.prefix}${num}`;
//         const display = `${section.prefix}${num}`;
//         return renderButton(id, display, section);
//       };

//       return (
//         <div className="flex gap-4 justify-center">
//           <div className="flex flex-col gap-2">
//             {leftColumnNums.map(renderButtonForNum)}
//           </div>

//           <div className="flex flex-col gap-2">
//             {rightColumnNums.map(renderButtonForNum)}
//           </div>
//         </div>
//       );
//     }

//     if (section.prefix === 'DP') {
//       const items = [];
//       let counter = 1;
//       for (let r = 0; r < section.rows; r++) {
//         for (let c = 0; c < section.cols; c++) {
//           const id = `${section.id}-${section.prefix}${counter}`;
//           const display = `${section.prefix}${counter}`;
//           items.push(
//             <div key={id} className="inline-block m-1">
//               {renderButton(id, display, section)}
//             </div>
//           );
//           counter++;
//         }
//       }
//       return <div className="grid grid-cols-1 gap-2 justify-center">{items}</div>;
//     }

//     if (section.count && section.prefix === 'P') {
//       const perRow = 2;
//       const rows = Math.ceil(section.count / perRow);

//       if (section.id === 'qawwali-left') {
//         const startNums = [1, 5, 9];
//         let idCounter = 1;
//         const gridRows = [];

//         for (let r = 0; r < rows; r++) {
//           const rowBtns = [];
//           for (let c = 0; c < perRow; c++) {
//             const id = `${section.id}-${section.prefix}${idCounter}`;
//             const displayNum = startNums[r] + c;
//             rowBtns.push(
//               <div key={id} className="inline-block m-1">
//                 {renderButton(id, `${section.prefix}${displayNum}`, section)}
//               </div>
//             );
//             idCounter++;
//           }
//           gridRows.push(<div key={`qleft-row-${r}`} className="flex gap-4 justify-center w-full">{rowBtns}</div>);
//         }

//         return <div className="flex flex-col gap-3 w-full">{gridRows}</div>;
//       }

//       if (section.id === 'qawwali-right') {
//         const startNums = [3, 7, 11];
//         let idCounter = 1;
//         const gridRows = [];

//         for (let r = 0; r < rows; r++) {
//           const rowBtns = [];
//           for (let c = 0; c < perRow; c++) {
//             const id = `${section.id}-${section.prefix}${idCounter}`;
//             const displayNum = startNums[r] + c;
//             rowBtns.push(
//               <div key={id} className="inline-block m-1">
//                 {renderButton(id, `${section.prefix}${displayNum}`, section)}
//               </div>
//             );
//             idCounter++;
//           }
//           gridRows.push(<div key={`qright-row-${r}`} className="flex gap-4 justify-center w.full">{rowBtns}</div>);
//         }

//         return <div className="flex flex-col gap-3 w.full">{gridRows}</div>;
//       }

//       const perRowDefault = 4;
//       const rowsDefault = Math.ceil(section.count / perRowDefault);
//       const rowNodes = Array.from({ length: rowsDefault }).map((_, r) => {
//         const base = r * perRowDefault;
//         const nums = [base + 1, base + 2, base + 3, base + 4];
//         const makeBtn = (num) => {
//           if (num > section.count) return <div key={`empty-${num}`} className="w-14 h-14" />;
//           const id = `${section.id}-${section.prefix}${num}`;
//           return <div key={id} className="inline-block m-1">{renderButton(id, `${section.prefix}${num}`, section)}</div>;
//         };

//         return (
//           <div key={r} className="flex justify-between items-center gap-6 w-full">
//             <div className="flex flex-col gap-3">{makeBtn(nums[0])}{makeBtn(nums[2])}</div>
//             <div className="flex flex-col gap-3">{makeBtn(nums[1])}{makeBtn(nums[3])}</div>
//           </div>
//         );
//       });

//       return <div className="flex flex-col gap-4 w-full">{rowNodes}</div>;
//     }

//     if (section.count && (section.prefix === 'PS' || section.prefix === 'DS')) {
//       const perRow = section.count === 20 ? 5 : section.count === 44 ? 11 : 4;

//       if (section.id === 'sofa-left' && section.count === 20) {
//         const rows = 4;
//         const startNumbers = [1, 11, 21, 31];
//         let idCounter = 1;
//         const gridRows = [];

//         for (let r = 0; r < rows; r++) {
//           const rowBtns = [];
//           for (let c = 0; c < perRow; c++) {
//             const id = `${section.id}-${section.prefix}${idCounter}`;
//             const displayNum = startNumbers[r] + c;
//             rowBtns.push(
//               <div key={id} className="inline-block m-1">
//                 {renderButton(id, `${section.prefix}${displayNum}`, section)}
//               </div>
//             );
//             idCounter++;
//           }
//           gridRows.push(<div key={`row-${r}`} className="flex gap-2 justify-center">{rowBtns}</div>);
//         }

//         return <div className="flex flex-col gap-2">{gridRows}</div>;
//       }

//       if (section.id === 'sofa-right' && section.count === 20) {
//         const rows = 4;
//         const startNumbers = [6, 16, 26, 36];
//         let idCounter = 1;
//         const gridRows = [];

//         for (let r = 0; r < rows; r++) {
//           const rowBtns = [];
//           for (let c = 0; c < perRow; c++) {
//             const id = `${section.id}-${section.prefix}${idCounter}`;
//             const displayNum = startNumbers[r] + c;
//             rowBtns.push(
//               <div key={id} className="inline-block m-1">
//                 {renderButton(id, `${section.prefix}${displayNum}`, section)}
//               </div>
//             );
//             idCounter++;
//           }
//           gridRows.push(<div key={`row-${r}`} className="flex gap-2 justify-center">{rowBtns}</div>);
//         }

//         return <div className="flex flex-col gap-2">{gridRows}</div>;
//       }

//       const items = Array.from({ length: section.count }).map((_, i) => {
//         const id = `${section.id}-${section.prefix}${i + 1}`;
//         return <div key={id} className="inline-block m-1">{renderButton(id, `${section.prefix}${i + 1}`, section)}</div>;
//       });

//       return (
//         <div className="grid gap-2 justify-center" style={{ gridTemplateColumns: `repeat(${perRow}, minmax(0, 1fr))` }}>
//           {items}
//         </div>
//       );
//     }

//     return null;
//   };

//   return (
//     <div className="p-6 bg-white min-h-screen text-gray-900">
//       <div className="max-w-8xl w-[90%] mx-auto">
//         <div className="text-center font-extrabold text-3xl mb-6">STAGE LAYOUT</div>

//         {message && <div className="mb-4 text-center text-sm text-red-600">{message}</div>}

//         <div className="flex justify-center mb-6">
//           <div className="w-1/4  text-black rounded-lg flex items-center justify-center gap-2 text-[34px] font-extrabold">Left Lounge</div>
//           <div className="w-2/4 bg-red-900 text-white rounded-lg flex items-center justify-center" style={{ height: 120 }}>
//             <span className="text-4xl font-black">STAGE</span>
//           </div>
//           <div className="w-1/4  text-black rounded-lg flex items-center justify-center text-[34px] font-extrabold">Right Lounge</div>
//         </div>

//         <div className="grid grid-cols-12 gap-4">
//           <div className="col-span-4">
//             <div className="grid grid-cols-3 gap-4">
//               <div className="bg-white p-3 rounded shadow-sm border">
//                 <h3 className="font-semibold text-sm mb-2">{SECTIONS[0].title}</h3>
//                 {renderTables(SECTIONS[0])}
//               </div>

//               <div className="bg-white p-3 rounded shadow-sm border">
//                 <h3 className="font-semibold text-sm mb-2">{SECTIONS[1].title}</h3>
//                 {renderTables(SECTIONS[1])}
//               </div>

//               <div className="bg-white p-3 rounded shadow-sm border">
//                 <h3 className="font-semibold text-sm mb-2">{SECTIONS[2].title}</h3>
//                 {renderTables(SECTIONS[2])}
//               </div>
//             </div>
//           </div>

//           <div className="col-span-4">
//             <div className="bg-white p-3 rounded shadow-sm border flex items-start gap-4">
//               <div className="flex-1">
//                 <h3 className="font-semibold text-sm mb-2">{SECTIONS[3].title}</h3>
//                 {renderTables(SECTIONS[3])}
//               </div>

//               <div className="w-20 flex items-center justify-center">
//                 <div
//                   className="bg-red-900 text-white rounded h-[265px] w-full flex items-center justify-center font-bold"
//                   style={{ writingMode: "vertical-rl" }}
//                 >
//                   STAGE
//                 </div>
//               </div>

//               <div className="flex-1">
//                 <h3 className="font-semibold text-sm mb-2">{SECTIONS[4].title}</h3>
//                 {renderTables(SECTIONS[4])}
//               </div>
//             </div>
//           </div>

//           <div className="col-span-4">
//             <div className="grid grid-cols-3 gap-4">
//               <div className="bg-white p-3 rounded shadow-sm border">
//                 <h3 className="font-semibold text-sm mb-2">{SECTIONS[7].title}</h3>
//                 {renderTables(SECTIONS[7])}
//               </div>

//               <div className="bg-white p-3 rounded shadow-sm border">
//                 <h3 className="font-semibold text-sm mb-2">{SECTIONS[6].title}</h3>
//                 {renderTables(SECTIONS[6])}
//               </div>

//               <div className="bg-white p-3 rounded shadow-sm border">
//                 <h3 className="font-semibold text-sm mb-2">{SECTIONS[5].title}</h3>
//                 {renderTables(SECTIONS[5])}
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="grid grid-cols-12 gap-2 mt-6">
//           <div className="col-span-4">
//             <div className="bg-white p-3 rounded shadow-sm border">
//               <h3 className="font-semibold text-sm mb-2">{SECTIONS[10].title}</h3>
//               {renderTables(SECTIONS[10])}
//             </div>
//           </div>
//           <div className="col-span-2">
//             <div className="bg-white p-3 rounded shadow-sm border">
//               <h3 className="font-semibold text-sm mb-2">{SECTIONS[8].title}</h3>
//               {renderTables(SECTIONS[8])}
//             </div>
//           </div>
//           <div className="col-span-2">
//             <div className="bg-white p-3 rounded shadow-sm border">
//               <h3 className="font-semibold text-sm mb-2">{SECTIONS[9].title}</h3>
//               {renderTables(SECTIONS[9])}
//             </div>
//           </div>
//           <div className="col-span-4">
//             <div className="bg-white p-3 rounded shadow-sm border">
//               <h3 className="font-semibold text-sm mb-2">{SECTIONS[11].title}</h3>
//               {renderTables(SECTIONS[11])}
//             </div>
//           </div>
//         </div>

//         <div className="mt-6 bg-white p-4 rounded shadow-sm flex items-center justify-between">
//           <div className="flex items-center gap-4 flex-wrap">
//             {Object.keys(COLORS).filter(k => k !== 'stage').map(k => (
//               <div key={k} className="flex items-center gap-2">
//                 <div style={{ background: COLORS[k] }} className="w-6 h-6 rounded-sm border" />
//                 <div className="text-sm capitalize">{k.replace('-', ' ')}</div>
//               </div>
//             ))}
//           </div>

//           <div className="flex items-center gap-3">
//             <div className="text-sm mr-4">{isAdmin ? 'Click any available seat to open booking popup' : 'You have view-only access'}</div>
//           </div>
//         </div>

//         {loading && <div className="text-center mt-4 text-sm text-gray-600">Loading booked seats...</div>}
//       </div>

//       {/* Modal */}
//       {modalOpen && modalSeat && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center">
//           <div className="absolute inset-0 bg-black opacity-50" onClick={closeModal} />

//           <div className="relative bg-white rounded-lg p-6 w-full max-w-md shadow-lg z-10">
//             <h3 className="text-lg font-bold mb-4">Book Seat {modalSeat.display}</h3>

//             <div className="flex flex-col gap-3">
//               <label className="text-sm">Guest name</label>
//               <input value={guestName} onChange={(e) => setGuestName(e.target.value)} className="border px-3 py-2 rounded" />

//               <label className="text-sm">Email (optional)</label>
//               <input value={guestEmail} onChange={(e) => setGuestEmail(e.target.value)} className="border px-3 py-2 rounded" />

//               <label className="text-sm">Contact (optional)</label>
//               <input value={guestContactState} onChange={(e) => setGuestContactState(e.target.value)} className="border px-3 py-2 rounded" />

//               <div className="flex items-center justify-end gap-2 mt-4">
//                 <button onClick={closeModal} className="px-4 py-2 bg-gray-200 rounded">Cancel</button>
//                 {/* Save only shown and enabled for admin, but modal itself only opens for admin so this is extra safety */}
//                 {isAdmin && <button onClick={handleModalSave} disabled={saving} className="px-4 py-2 bg-indigo-600 text-white rounded">{saving ? 'Saving...' : 'Save'}</button>}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Toasts */}
//       <ToastContainer toasts={toasts} removeToast={removeToast} />
//     </div>
//   );
// }


// StageLayoutWithAPI.jsx
import React, { useEffect, useState, useMemo } from "react";
import { API } from "../config/api";
import { get, post } from "../lib/http";
import AuthModal from "../pages/AuthModal.jsx"; // reuse same modal as Header

const MIN_WIDTH = 1100; // tune as needed

const SECTIONS = [
  { id: 'left-diamond', title: 'Mehfil - Diamond Silver', category: 'diamond-silver', rows: 2, cols: 4, prefix: 'DS-' },
  { id: 'left-gold', title: 'Mehfil - Diamond Gold', category: 'diamond-gold', rows: 2, cols: 4, prefix: 'DG' },
  { id: 'left-platinum', title: 'Mehfil - Diamond Platinum', category: 'diamond-platinum', rows: 1, cols: 4, prefix: 'DP' },
  { id: 'qawwali-left', title: 'Qawwali Court', category: 'platinum', count: 6, prefix: 'P' },
  { id: 'qawwali-right', title: 'Qawwali Court', category: 'platinum', count: 6, prefix: 'P' },
  { id: 'right-diamond', title: 'Mehfil - Diamond Silver', category: 'diamond-silver', rows: 2, cols: 4, prefix: 'DS-' },
  { id: 'right-gold', title: 'Mehfil - Diamond Gold', category: 'diamond-gold', rows: 2, cols: 4, prefix: 'DG' },
  { id: 'right-platinum', title: 'Mehfil - Diamond Platinum', category: 'diamond-platinum', rows: 1, cols: 4, prefix: 'DP' },
  { id: 'sofa-left', title: 'Mehfil - 20 Sofa Lounge', category: 'qawwali-sofa', count: 20, prefix: 'PS' },
  { id: 'sofa-right', title: 'Mehfil - 20  Sofa Lounge', category: 'qawwali-sofa', count: 20, prefix: 'PS' },
  { id: '44sofa-left', title: 'Qawwali -  44 Sofa Lounge', category: 'mehfil-sofa', count: 44, prefix: 'DS' },
  { id: '44sofa-right', title: 'Qawwali - 44 Sofa Lounge', category: 'mehfil-sofa', count: 44, prefix: 'DS' }
];

const COLORS = {
  'diamond-silver': '#9be39b',
  'diamond-gold': '#6fb7ff',
  'diamond-platinum': '#ffd97a',
  'platinum': '#fa8110ff',
  'mehfil-sofa': '#0c3f85ff',
  'qawwali-sofa': '#e43e14ff',
  'stage': '#8b0000'
};

const PRICES = {
  'diamond-silver': 50,
  'diamond-gold': 75,
  'diamond-platinum': 100,
  'platinum': 150,
  'mehfil-sofa': 40,
  'qawwali-sofa': 60
};

function ToastContainer({ toasts, removeToast }) {
  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map(t => (
        <div key={t.id} className={`px-4 py-2 rounded shadow-lg text-white text-sm ${t.type === 'error' ? 'bg-red-600' : 'bg-green-600'}`}>
          {t.message}
          <button onClick={() => removeToast(t.id)} className="ml-3 font-bold">✕</button>
        </div>
      ))}
    </div>
  );
}

export default function StageLayoutWithAPI({
  userId = null,
  userName = '',
  userContact = '',
  userRole = undefined
}) {
  const [booked, setBooked] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  // booking modal
  const [modalOpen, setModalOpen] = useState(false);
  const [modalSeat, setModalSeat] = useState(null);
  const [guestName, setGuestName] = useState('');
  const [guestEmail, setGuestEmail] = useState('');
  const [guestContactState, setGuestContactState] = useState('');

  // toasts
  const [toasts, setToasts] = useState([]);
  const addToast = (message, type = 'success', timeout = 3500) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);
    if (timeout) setTimeout(() => removeToast(id), timeout);
  };
  const removeToast = (id) => setToasts(prev => prev.filter(t => t.id !== id));

  // AuthModal state (reuse same modal as Header)
  const [authOpen, setAuthOpen] = useState(false);
  const [authTab, setAuthTab] = useState("login"); // 'login' | 'register'
  const [nextAfterAuth, setNextAfterAuth] = useState("/");

  const openAuth = (tab = "login", next = "/") => {
    setAuthTab(tab);
    setNextAfterAuth(next);
    setAuthOpen(true);
  };

  const closeAuth = () => {
    setAuthOpen(false);
  };

  // helpers
  const getToken = () => {
    try {
      return JSON.parse(localStorage.getItem("bb_user"))?.token;
    } catch (e) {
      return null;
    }
  };

  const isAdmin = useMemo(() => {
    if (userRole) return userRole === 'admin';
    try {
      const stored = JSON.parse(localStorage.getItem('bb_user'));
      const r = stored?.user?.role || stored?.role || stored?.user?.isAdmin;
      if (typeof r === 'string') return r === 'admin';
      return !!r;
    } catch (e) {
      return false;
    }
  }, [userRole]);

  const seatIdToSection = useMemo(() => {
    const map = {};
    SECTIONS.forEach(s => {
      if (s.rows) {
        let counter = 1;
        for (let r = 0; r < s.rows; r++) {
          for (let c = 0; c < s.cols; c++) {
            const code = `${s.id}-${s.prefix}${counter}`;
            map[code] = s;
            counter++;
          }
        }
      } else if (s.count) {
        for (let i = 1; i <= s.count; i++) {
          const code = `${s.id}-${s.prefix}${i}`;
          map[code] = s;
        }
      }
    });
    return map;
  }, []);

  useEffect(() => {
    // if not logged in, open the auth modal on first load (same behavior as header)
    const token = getToken();
    if (!token) {
      openAuth("login", window.location.pathname + window.location.search);
    }
  }, []);

  // load booked seats
  useEffect(() => {
    let mounted = true;
    const loadBooked = async () => {
      setLoading(true);
      try {
        const token = getToken();
        const resp = await get(API.layout.listAllBooked, {
          headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "application/json" }
        });
        if (!resp.success) throw new Error(`HTTP ${resp.status}`);
        const body = await resp;
        if (!mounted) return;
        const bookedMap = {};
        (body.items || []).forEach(it => { if (it.seatCode) bookedMap[it.seatCode] = true; });
        setBooked(bookedMap);
        setMessage(null);
      } catch (err) {
        console.error('Failed to load booked seats', err);
        setMessage(`Could not load booked seats (server). Showing local state only.`);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    loadBooked();
    return () => { mounted = false; };
  }, []);

  // ensure logged in or prompt
  const ensureLoggedInOrPrompt = () => {
    const token = getToken();
    if (!token) {
      openAuth("login", window.location.pathname + window.location.search);
      addToast('Please login first', 'error', 2000);
      return false;
    }
    return true;
  };

  const openModalForSeat = (seatId, display, section) => {
    if (!ensureLoggedInOrPrompt()) return;

    if (!isAdmin) {
      addToast('View only: you do not have permission to book seats.', 'error', 2000);
      return;
    }
    if (booked[seatId]) return;
    setModalSeat({ id: seatId, display, section });
    const stored = JSON.parse(localStorage.getItem('bb_user')) || {};
    setGuestName(userName || stored?.user?.name || '');
    setGuestContactState(userContact || stored?.user?.contact || '');
    setGuestEmail('');
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalSeat(null);
    setGuestName('');
    setGuestEmail('');
    setGuestContactState('');
  };

  const buildSeatsPayload = (seatCodes, guest) => {
    return seatCodes.map(code => {
      const sec = seatIdToSection[code];
      return {
        seatCode: code,
        sectionUid: sec?.id || null,
        label: code.split('-').slice(-1)[0],
        category: sec?.category || null,
        price: PRICES[sec?.category] || 0,
        meta: { source: 'web-frontend', guest: guest || null }
      };
    });
  };

  const handleModalSave = async () => {
    if (!modalSeat) return;
    if (!guestName) {
      addToast('Guest name is required', 'error');
      return;
    }

    if (!guestContactState) {
      addToast('Guest Countact Number is required', 'error');
      return;
    }

    const seatCode = modalSeat.id;
    if (booked[seatCode]) {
      addToast('Sorry, this seat was just booked by someone else.', 'error');
      closeModal();
      return;
    }

    setSaving(true);
    setMessage(null);
    try {
      const payloadSeats = buildSeatsPayload([seatCode], { name: guestName, email: guestEmail, contact: guestContactState });
      const body = {
        userId: userId || undefined,
        bookedByName: guestName || userName || undefined,
        bookedByContact: guestContactState || userContact || undefined,
        bookingRef: `WEB_${Date.now()}`,
        seats: payloadSeats
      };

      const token = getToken();
      const resp = await post(API.layout.book, body, {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          "Content-Type": "application/json",
        },
      });
      const result = await resp;

      if (!resp.success) {
        const msg = (result && result.message) ? result.message : `Booking failed`;
        setMessage(msg);
        addToast(msg, 'error');
        if (result && result.conflicts) {
          const conflicts = result.conflicts.map(c => c.seatCode);
          setBooked(prev => ({ ...prev, ...conflicts.reduce((acc, c) => (acc[c] = true, acc), {}) }));
        }
        throw new Error(msg);
      }

      const newly = result.seats || payloadSeats.map(s => s.seatCode);
      setBooked(prev => {
        const cp = { ...prev };
        newly.forEach(s => cp[s] = true);
        return cp;
      });
      setMessage('Booking successful!');
      addToast(`Booking successful: ${newly.join(', ')}`, 'success');
      closeModal();
    } catch (err) {
      console.error('Modal save error', err);
      if (!message) {
        setMessage('Booking failed, try again.');
        addToast('Booking failed, try again.', 'error');
      }
    } finally {
      setSaving(false);
    }
  };

  // responsive seat button
  const renderButton = (id, display, section) => {
    const isBooked = !!booked[id];
    const bg = isBooked ? COLORS[section.category] : 'transparent';
    const color = isBooked ? '#fff' : '#111';
    const border = isBooked ? 'transparent' : 'rgba(0,0,0,0.08)';
    const clickable = isAdmin && !isBooked;

    const sizeStyle = {
      width: 'clamp(28px, 4.2vw, 48px)',
      height: 'clamp(28px, 4.2vw, 48px)',
      lineHeight: '1',
      boxSizing: 'border-box',
      zIndex: 2,
      background: bg,
      color,
      borderColor: border,
      flex: '0 0 auto',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center'
    };

    return (
      <button
        key={id}
        onClick={clickable ? () => openModalForSeat(id, display, section) : () => { if (!getToken()) { openAuth('login', window.location.pathname + window.location.search); addToast('Please login first', 'error', 2000); } }}
        disabled={!clickable}
        title={isBooked ? 'Booked' : (isAdmin ? 'Click to book' : 'View only')}
        className={`rounded-full border-2 font-semibold text-xs transition ${isBooked ? '' : (clickable ? 'hover:-translate-y-1 cursor-pointer' : 'cursor-default opacity-90')}`}
        style={sizeStyle}
      >
        <span style={{ fontSize: '0.75rem', display: 'inline-block', padding: '0 .25rem', textAlign: 'center', whiteSpace: 'nowrap' }}>
          {display}
        </span>
      </button>
    );
  };

  const seatWrapper = (id, children) => (
    <div key={id} className="inline-flex m-1" style={{ alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box' }}>
      {children}
    </div>
  );

  const renderSofaGrid = (section, perRow) => {
    if (section.count === 20 && (section.id === 'sofa-left' || section.id === 'sofa-right')) {
      const rows = 4;
      const perCol = 5; // columns per row
      const startNumbers = section.id === 'sofa-left'
        ? [1, 11, 21, 31]   // left block mapping (as original)
        : [6, 16, 26, 36];  // right block mapping (as original)

      let idCounter = 1;
      const gridRows = [];
      for (let r = 0; r < rows; r++) {
        const rowBtns = [];
        for (let c = 0; c < perCol; c++) {
          const id = `${section.id}-${section.prefix}${idCounter}`;
          const displayNum = startNumbers[r] + c;
          rowBtns.push(
            <div key={id} className="inline-flex m-1">
              {renderButton(id, `${section.prefix}${displayNum}`, section)}
            </div>
          );
          idCounter++;
        }
        gridRows.push(
          <div key={`sofa-${section.id}-row-${r}`} className="flex gap-2 justify-center">
            {rowBtns}
          </div>
        );
      }

      const maxHeight = 250;
      return (
        <div style={{ maxHeight: `${maxHeight}px`, overflowY: 'auto', paddingRight: 8, boxSizing: 'border-box' }} className="sofa-scroll">
          <div className="flex flex-col gap-1">
            {gridRows}
          </div>
        </div>
      );
    }

    // Default sofa rendering (sequential display numbers)
    const items = Array.from({ length: section.count }).map((_, i) => {
      const id = `${section.id}-${section.prefix}${i + 1}`;
      return (
        <div key={id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {renderButton(id, `${section.prefix}${i + 1}`, section)}
        </div>
      );
    });

    const maxHeight = section.count >= 40 ? 260 : 200;

    return (
      <div style={{ maxHeight: `${maxHeight}px`, overflowY: 'auto', paddingRight: 8, boxSizing: 'border-box' }} className="sofa-scroll">
        <div style={{ display: 'grid', gridTemplateColumns: `repeat(${perRow}, minmax(48px, 1fr))`, gap: '8px', alignItems: 'center', justifyItems: 'center' }}>
          {items}
        </div>
      </div>
    );
  };

  const renderTables = (section) => {
    if (!section) return null;

    if (section.prefix === 'DS-') {
      const total = (section.rows || 0) * (section.cols || 0);
      const nums = Array.from({ length: total }, (_, i) => i + 1);
      const half = Math.ceil(total / 2);
      const firstHalf = nums.slice(0, half);
      const secondHalf = nums.slice(half);
      const isLeftSection = section.id.includes('left');
      const leftColumnNums = isLeftSection ? secondHalf : firstHalf;
      const rightColumnNums = isLeftSection ? firstHalf : secondHalf;

      const renderButtonForNum = (num) => {
        const id = `${section.id}-${section.prefix}${num}`;
        const display = `${section.prefix}${num}`;
        return seatWrapper(id, renderButton(id, display, section));
      };

      return (
        <div className="flex gap-4 justify-center">
          <div className="flex flex-col gap-2">
            {leftColumnNums.map(renderButtonForNum)}
          </div>

          <div className="flex flex-col gap-2">
            {rightColumnNums.map(renderButtonForNum)}
          </div>
        </div>
      );
    }

    if (section.prefix === 'DG') {
      const total = (section.rows || 0) * (section.cols || 0);
      const nums = Array.from({ length: total }, (_, i) => i + 1);
      const half = Math.ceil(total / 2);
      const firstHalf = nums.slice(0, half);
      const secondHalf = nums.slice(half);
      const isLeftSection = section.id.includes('left');
      const leftColumnNums = isLeftSection ? secondHalf : firstHalf;
      const rightColumnNums = isLeftSection ? firstHalf : secondHalf;

      const renderButtonForNum = (num) => {
        const id = `${section.id}-${section.prefix}${num}`;
        const display = `${section.prefix}${num}`;
        return seatWrapper(id, renderButton(id, display, section));
      };

      return (
        <div className="flex gap-4 justify-center">
          <div className="flex flex-col gap-2">
            {leftColumnNums.map(renderButtonForNum)}
          </div>

          <div className="flex flex-col gap-2">
            {rightColumnNums.map(renderButtonForNum)}
          </div>
        </div>
      );
    }

    if (section.prefix === 'DP') {
      const items = [];
      let counter = 1;
      for (let r = 0; r < section.rows; r++) {
        for (let c = 0; c < section.cols; c++) {
          const id = `${section.id}-${section.prefix}${counter}`;
          const display = `${section.prefix}${counter}`;
          items.push(
            <div key={id} className="inline-flex m-1">{renderButton(id, display, section)}</div>
          );
          counter++;
        }
      }
      return <div className="grid grid-cols-1 gap-2 justify-center">{items}</div>;
    }

    // small qawwali group
    if (section.count && section.prefix === 'P') {
      const perRowDefault = 2;
      const rowsDefault = Math.ceil(section.count / perRowDefault);

      if (section.id === 'qawwali-left' || section.id === 'qawwali-right') {
        const startNums = section.id === 'qawwali-left' ? [1, 5, 9] : [3, 7, 11];
        let idCounter = 1;
        const gridRows = [];

        for (let r = 0; r < rowsDefault; r++) {
          const rowBtns = [];
          for (let c = 0; c < perRowDefault; c++) {
            const id = `${section.id}-${section.prefix}${idCounter}`;
            const displayNum = startNums[r] + c;
            rowBtns.push(
              <div key={id} className="inline-flex m-1">
                {renderButton(id, `${section.prefix}${displayNum}`, section)}
              </div>
            );
            idCounter++;
          }
          gridRows.push(<div key={`qrow-${r}`} className="flex gap-4 justify-center w-full">{rowBtns}</div>);
        }

        return <div className="flex flex-col gap-3 w-full">{gridRows}</div>;
      }

      const rowNodes = Array.from({ length: rowsDefault }).map((_, r) => {
        const base = r * 2;
        const makeBtn = (num) => {
          if (num > section.count) return <div key={`empty-${num}`} className="w-14 h-14" />;
          const id = `${section.id}-${section.prefix}${num}`;
          return <div key={id} className="inline-flex m-1">{renderButton(id, `${section.prefix}${num}`, section)}</div>;
        };

        return (
          <div key={r} className="flex justify-between items-center gap-6 w-full">
            <div className="flex flex-col gap-3">{makeBtn(base + 1)}{makeBtn(base + 3)}</div>
            <div className="flex flex-col gap-3">{makeBtn(base + 2)}{makeBtn(base + 4)}</div>
          </div>
        );
      });

      return <div className="flex flex-col gap-4 w-full">{rowNodes}</div>;
    }

    // sofa sections
    if (section.count && (section.prefix === 'PS' || section.prefix === 'DS')) {
      let perRow = 4;
      if (section.count === 20) perRow = 5;
      if (section.count === 44) perRow = 11;
      return renderSofaGrid(section, perRow);
    }

    return null;
  };

  // ---------- render ----------
  return (
    <div className="p-6 bg-white min-h-screen text-gray-900">
      <div className="w-full overflow-auto responsive-scroll" style={{ WebkitOverflowScrolling: 'touch' }}>
        <div className="max-w-[1600px] mx-auto" style={{ minWidth: MIN_WIDTH }}>
          <div className="text-center font-extrabold text-3xl mb-6">STAGE LAYOUT</div>

          {message && <div className="mb-4 text-center text-sm text-red-600">{message}</div>}

          <div className="flex justify-center mb-6 gap-4 flex-wrap">
            <div className="w-60 text-black rounded-lg flex items-center justify-center gap-2 text-[24px] font-extrabold">Left Lounge</div>
            <div className="flex-1 max-w-2xl bg-red-900 text-white rounded-lg flex items-center justify-center" style={{ height: 120 }}>
              <span className="text-3xl font-black">STAGE</span>
            </div>
            <div className="w-60 text-black rounded-lg flex items-center justify-center text-[24px] font-extrabold">Right Lounge</div>
          </div>

          {/* main grid */}
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-4 flex-shrink-0 min-w-[300px]">
              <div className="grid grid-cols-3 gap-4">
                <div className="bg-white p-3 rounded shadow-sm border">
                  <h3 className="font-semibold text-sm mb-2">{SECTIONS[0].title}</h3>
                  {renderTables(SECTIONS[0])}
                </div>

                <div className="bg-white p-3 rounded shadow-sm border">
                  <h3 className="font-semibold text-sm mb-2">{SECTIONS[1].title}</h3>
                  {renderTables(SECTIONS[1])}
                </div>

                <div className="bg-white p-3 rounded shadow-sm border">
                  <h3 className="font-semibold text-sm mb-2">{SECTIONS[2].title}</h3>
                  {renderTables(SECTIONS[2])}
                </div>
              </div>
            </div>

            <div className="col-span-4 flex-shrink-0 min-w-[360px]">
              <div className="bg-white p-3 rounded shadow-sm border flex items-start gap-4">
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-sm mb-2">{SECTIONS[3].title}</h3>
                  {renderTables(SECTIONS[3])}
                </div>

                <div className="w-20 flex items-center justify-center">
                  <div className="bg-red-900 text-white rounded h-[265px] w-full flex items-center justify-center font-bold" style={{ writingMode: "vertical-rl" }}>
                    STAGE
                  </div>
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-sm mb-2">{SECTIONS[4].title}</h3>
                  {renderTables(SECTIONS[4])}
                </div>
              </div>
            </div>

            <div className="col-span-4 flex-shrink-0 min-w-[300px]">
              <div className="grid grid-cols-3 gap-4">
                <div className="bg-white p-3 rounded shadow-sm border">
                  <h3 className="font-semibold text-sm mb-2">{SECTIONS[7].title}</h3>
                  {renderTables(SECTIONS[7])}
                </div>

                <div className="bg-white p-3 rounded shadow-sm border">
                  <h3 className="font-semibold text-sm mb-2">{SECTIONS[6].title}</h3>
                  {renderTables(SECTIONS[6])}
                </div>

                <div className="bg-white p-3 rounded shadow-sm border">
                  <h3 className="font-semibold text-sm mb-2">{SECTIONS[5].title}</h3>
                  {renderTables(SECTIONS[5])}
                </div>
              </div>
            </div>
          </div>

          {/* bottom row */}
          <div className="grid grid-cols-12 gap-2 mt-6">
            <div className="col-span-3 flex-shrink-0 min-w-[240px]">
              <div className="bg-white p-3 rounded shadow-sm border">
                <h3 className="font-semibold text-sm mb-2">{SECTIONS[10].title}</h3>
                {renderTables(SECTIONS[10])}
              </div>
            </div>
            <div className="col-span-3 flex-shrink-0 min-w-[240px]">
              <div className="bg-white p-3 rounded shadow-sm border">
                <h3 className="font-semibold text-sm mb-2">{SECTIONS[8].title}</h3>
                {renderTables(SECTIONS[8])}
              </div>
            </div>
            <div className="col-span-3 flex-shrink-0 min-w-[240px]">
              <div className="bg-white p-3 rounded shadow-sm border">
                <h3 className="font-semibold text-sm mb-2">{SECTIONS[9].title}</h3>
                {renderTables(SECTIONS[9])}
              </div>
            </div>
            <div className="col-span-3 flex-shrink-0 min-w-[240px]">
              <div className="bg-white p-3 rounded shadow-sm border">
                <h3 className="font-semibold text-sm mb-2">{SECTIONS[11].title}</h3>
                {renderTables(SECTIONS[11])}
              </div>
            </div>
          </div>

          {/* legend/info */}
          <div className="mt-6 bg-white p-4 rounded shadow-sm flex items-center justify-between">
            <div className="flex items-center gap-4 flex-wrap">
              {Object.keys(COLORS).filter(k => k !== 'stage').map(k => (
                <div key={k} className="flex items-center gap-2">
                  <div style={{ background: COLORS[k] }} className="w-6 h-6 rounded-sm border" />
                  <div className="text-sm capitalize">{k.replace('-', ' ')}</div>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3">
              <div className="text-sm mr-4">{isAdmin ? 'Click any available seat to open booking popup' : 'You have view-only access'}</div>
            </div>
          </div>

          {loading && <div className="text-center mt-4 text-sm text-gray-600">Loading booked seats...</div>}
        </div>
      </div>

      {/* Booking modal */}
      {modalOpen && modalSeat && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black opacity-50" onClick={closeModal} />
          <div className="relative bg-white rounded-lg p-6 w-full max-w-md sm:max-w-lg mx-4 shadow-lg z-10 max-h-[90vh] overflow-auto">
            <h3 className="text-lg font-bold mb-4">Book Seat {modalSeat.display}</h3>
            <div className="flex flex-col gap-3">
              <label className="text-sm">Guest name</label>
              <input value={guestName} onChange={(e) => setGuestName(e.target.value)} className="border px-3 py-2 rounded" />
              <label className="text-sm">Email (optional)</label>
              <input value={guestEmail} onChange={(e) => setGuestEmail(e.target.value)} className="border px-3 py-2 rounded" />
              <label className="text-sm">Contact</label>
              <input value={guestContactState} onChange={(e) => setGuestContactState(e.target.value)} className="border px-3 py-2 rounded" />
              <div className="flex items-center justify-end gap-2 mt-4">
                <button onClick={closeModal} className="px-4 py-2 bg-gray-200 rounded">Cancel</button>
                {isAdmin && <button onClick={handleModalSave} disabled={saving} className="px-4 py-2 bg-indigo-600 text-white rounded">{saving ? 'Saving...' : 'Save'}</button>}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Reuse header-style AuthModal */}
      <AuthModal
        open={authOpen}
        onClose={() => closeAuth()}
        defaultTab={authTab}
        next={nextAfterAuth}
        headerVariant="logo"
      />

      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </div>
  );
}
